import { Immutable } from "immer";
import React from "react";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { OrderConfirmationFooter } from "../OrderConfirmationFooter";
import { OrderConfirmationHeader } from "../OrderConfirmationHeader";

import styles from "./index.module.scss";

type IProps = Immutable<templates.OrderPendingDocumentTemplate>;

export const OrderPendingBody = (props: IProps): React.JSX.Element => {
    return (
        <section
            id="order-detail"
            className="order-confirmation l-capped-width"
        >
            <div
                id="thanks"
                data-qty={props.order_num_items}
                data-revenue={props.order_revenue}
                data-number={props.order_number}
                data-continue-url={props.continue_url}
            >
                <OrderConfirmationHeader>
                    <h1 className={styles.orderErrorIntroTitle}>
                        {t`We’re Sorry — There’s an Unexpected Issue with Your Order`}
                    </h1>
                    <div className={styles.orderErrorIntroCopy}>
                        <p>
                            {t`An error may have prevented us from receiving your order and payment information.`}
                        </p>
                        <p>
                            {t`Please check your email for an order confirmation from us. If you received the email, your order was placed successfully and you’re on your way to better sleep.`}
                        </p>
                        <p>
                            {t`If you didn’t receive an order confirmation, please follow these steps and try placing your order again:`}
                        </p>
                        <ol>
                            <li>{t`Use a different internet browser`}</li>
                            <li>{t`Submit your order using another device`}</li>
                            <li>
                                {t`Clear your browser’s cookies and search data`}
                            </li>
                        </ol>
                        <p>
                            {t`Rest assured that you will not be charged for an unsuccessful order attempt and that your personal details and payment information were not compromised.`}
                        </p>
                    </div>
                    <div>
                        <p className={styles.orderErrorIntroCopyBold}>
                            {t`If you’re still experiencing issues, please contact one of your Sleep Experts at ${props.support_phone_display}.`}
                            <br />
                            {t`We’re here ${props.support_hours} to assist you.`}
                        </p>
                    </div>
                    <div className={styles.orderErrorContinue}>
                        <a href="/">
                            <div
                                className={concatClassNames([
                                    "button",
                                    FORM_FIELD_SUBMIT_CLASS_NAME,
                                ])}
                            >
                                {t`Shop Now`}
                            </div>
                        </a>
                    </div>
                </OrderConfirmationHeader>
            </div>

            <OrderConfirmationFooter>
                <p>
                    {t`Any questions or concerns? You can contact us by calling toll-free`}{" "}
                    <strong>
                        <a href={props.cs_phone_rfc3966}>
                            {props.cs_phone_national}
                        </a>
                    </strong>{" "}
                    {t`or by sending an email to`}{" "}
                    <strong>
                        <a href={`mailto:${props.cs_email}`}>
                            {props.cs_email}
                        </a>
                    </strong>
                    .
                </p>
                <br />
                <p>Cocoon by Sealy, 1000 Tempur Way, Lexington, KY 40511</p>
            </OrderConfirmationFooter>
        </section>
    );
};
